export default {
  'Sales registry': 'Registro de ventas',
  'Sales registry subtitle': 'Gestiona los productos y servicios que podrán registrar los usuarios en la plataforma.',
  'Sales registry topbar subtitle': 'Administración de productos y servicios',
  'New product or service': 'Nuevo producto o servicio',
  'Creation date': 'Fecha de creación',
  'Product name': 'Nombre del producto/servicio',
  'Payment type': 'Tipo de pago',
  'Default price': 'Precio por defecto',
  'Default price optional': 'Precio por defecto (opcional)',
  'Description optional': 'Descripción (opcional)',
  Description: 'Descripción',
  'One-time payment': 'Único',
  'Recurring payment': 'Mensual',
  'No description': 'No hay descripción',
  'Add first product title': 'Agregar nuevo producto o servicio',
  'Sales currency intro':
    'Antes de registrar el primer producto o servicio, deberás asignar la moneda específica para la cuenta.',
  'Sales currency important': 'IMPORTANTE:',
  'Sales currency warning body':
    'la moneda elegida se aplicará a toda la cuenta y no podrá modificarse en un futuro.',
  'Choose currency': 'Elegir moneda',
  'Sales currency footnote':
    '*Esto se mostrará solamente la primera vez que vamos a crear un producto o servicio.',
  'Edit product': 'Editar producto o servicio',
  'Delete product or service': 'Eliminar producto o servicio',
  'Delete product service confirm':
    'Esta acción no se puede deshacer.',
  Sales: 'Ventas',
  'Add sale': 'Agregar venta',
  'Add product': 'Agregar producto',
  'Go to catalog': 'Ir al catálogo',
  'Add product or service': 'Agregar producto o servicio',
  'Tooltip sale needs catalog admin':
    'Antes de agregar una venta, primero debes agregar un producto o servicio.',
  'Tooltip sale needs catalog staff':
    'Antes de agregar una venta, primero un manager o administrador debe agregar un producto o servicio.',
  'Register new sale': 'Registrar nueva venta',
  'Save sale': 'Guardar venta',
  'Note optional': 'Nota (opcional)',
  Price: 'Precio',
  'No sales for client': 'Aún no hay ventas registradas para este contacto.',
  'Edit sale': 'Editar venta',
  Product: 'Producto o servicio',
  'Removed from catalog': 'eliminado',
  Amount: 'Monto',
  'Sale date': 'Fecha de la venta',
  'Delete sale': '¿Eliminar esta venta?',
  'Delete sale confirm': 'Esta acción no se puede deshacer.',
  'Sales popover intro':
    'Activa el registro de ventas para comenzar a medir tus resultados en Uniboxi.',
  'Sales popover with sales registry link':
    'Para empezar, ve a Registro de ventas y crea tu primer producto o servicio.',
  'Sales popover admin required':
    'Solo un admin o manager puede crear productos o servicios. Pedile a un administrador que lo haga.',
  salesCountSummary: '{{count}} ventas',
  monthAbbr: 'mes',
  monthWord: 'mes',
  'Sales metrics': 'Métricas de ventas',
  'Empty sales metrics title': 'Mide las ventas que te genera Uniboxi',
  'Empty sales metrics text 1':
    'Deja de adivinar. Registra las ventas que llegan por WhatsApp, Messenger e Instagram y ve cuánto estás vendiendo gracias a Uniboxi. Identifica qué productos o servicios se venden más y qué usuarios están convirtiendo más leads en ventas.',
  'Empty sales metrics admin note':
    'Solo un administrador o manager puede activarlo.',
  'Empty sales metrics start now': 'Comenzar ahora',
  'Sales records': 'Registro de ventas',
  Quantity: 'Cantidad',
  'Recurring sale': 'Venta mensualidad',
  'One-time sale': 'Venta única',
  'Closing rate by user': 'Tasa de cierre por usuario',
  'Conversations created in period and sales made in those conversations': 'Conversaciones creadas en el periodo y ventas realizadas en esas conversaciones',
  'Sales count': 'Ventas registradas',
  'Total amount': 'Monto total',
  'Closing rate': 'Tasa de cierre',
  'Total sales': 'Ventas totales',
  'Sales totals': 'Ventas',
  'Detail with all sales in filtered period': 'Detalle con todas las ventas en el periodo filtrado',
  'Client name': 'Nombre del cliente',
  'Product/service': 'Producto/servicio',
  'Sales summary per user': 'Resumen de ventas por usuario',
  'Includes all sales in filtered period': 'Incluye todas las ventas en el periodo filtrado',
};
